var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import ButtonDropdown from "@cloudscape-design/components/button-dropdown";
import Box from "@cloudscape-design/components/box";
import { useFileExplorerStore } from "../store";
import { CenterContent } from "../../center";
import { BreadCrumbs } from "./BreadCrumbs";
/**
 * Table header component
 * This component is responsible for rendering the table header in the file explorer
 * It takes in the following props:
 * @param {IActions} actions - The actions object that contains the functions that are used to perform actions on the file explorer
 * @param {boolean} isFetching - A boolean that indicates whether the file explorer is fetching data from the server
 * @param {React.ReactNode} children - A react node that is rendered in the table header
 * @param {I18n} i18nStrings - An object that contains the i18n strings that are used in the file explorer
 */
export var TableHeader = function (_a) {
    var actions = _a.actions, isFetching = _a.isFetching, children = _a.children, i18nStrings = _a.i18nStrings, _b = _a.showActions, showActions = _b === void 0 ? true : _b, allowedActions = _a.allowedActions, rootPath = _a.rootPath;
    var hiddenFileUploadInput = React.useRef(null);
    var uploadingFileProgress = useFileExplorerStore(function (s) { return s.uploading.currentFileUploadPercentage; });
    var selectedFiles = useFileExplorerStore(function (s) { return s.selectedFiles; });
    var uploadingFileIndex = useFileExplorerStore(function (s) { return s.uploading.currentFileIndex; });
    var uploadingFileCount = useFileExplorerStore(function (s) { var _a, _b; return (_b = (_a = s.uploading.files) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; });
    var isUploading = uploadingFileProgress !== null &&
        uploadingFileIndex !== null &&
        uploadingFileCount !== null;
    var path = useFileExplorerStore(function (s) { return s.path; });
    var dropdownActionsIdMapping = {
        rename: "rename",
        download: "download",
        delete: "delete",
    };
    var buttonDropdownItems = [];
    if (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.rename) {
        buttonDropdownItems.push({
            text: i18nStrings.rename,
            id: dropdownActionsIdMapping.rename,
            disabled: selectedFiles.length !== 1,
        });
    }
    if (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.delete) {
        buttonDropdownItems.push({
            text: i18nStrings.delete,
            id: dropdownActionsIdMapping.delete,
            disabled: Boolean(selectedFiles.length === 0 ||
                selectedFiles.find(function (el) { return el.type === "folder"; })),
        });
    }
    if (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.download) {
        buttonDropdownItems.push({
            text: i18nStrings.download,
            id: dropdownActionsIdMapping.download,
            disabled: Boolean(selectedFiles.length === 0 ||
                selectedFiles.find(function (el) { return el.type === "folder"; })),
        });
    }
    return (_jsxs(SpaceBetween, __assign({ size: "s", direction: "vertical" }, { children: [_jsx(BreadCrumbs, { path: path !== null && path !== void 0 ? path : "/", onClick: function (path) {
                    useFileExplorerStore.setState({ path: path });
                }, ariaLabel: i18nStrings.breadCrumbAriaLabel, rootPath: rootPath }), _jsxs(SpaceBetween, __assign({ size: "s", direction: "horizontal" }, { children: [showActions && buttonDropdownItems.length > 0 && (_jsx(ButtonDropdown, __assign({ items: buttonDropdownItems, ariaLabel: i18nStrings.actions, onItemClick: function (_a) {
                            var detail = _a.detail;
                            return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (detail.id === dropdownActionsIdMapping.rename) {
                                                if (selectedFiles.length === 1) {
                                                    actions.onRenameClick(selectedFiles);
                                                }
                                                else {
                                                    console.warn("Invalid selectedFiles length for rename operation ".concat(selectedFiles.length));
                                                }
                                                return [2 /*return*/];
                                            }
                                            if (!(detail.id === dropdownActionsIdMapping.delete)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, actions.deleteFiles(selectedFiles)];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                        case 2:
                                            if (!(detail.id === dropdownActionsIdMapping.download)) return [3 /*break*/, 4];
                                            return [4 /*yield*/, actions.downloadFiles(selectedFiles)];
                                        case 3:
                                            _b.sent();
                                            _b.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            });
                        } }, { children: i18nStrings.actions }))), showActions && (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.createFolder) && (_jsx(Button, __assign({ onClick: actions.onCreateFolderClick }, { children: i18nStrings.createFolder }))), showActions && (allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.upload) && (_jsxs(Button, __assign({ formAction: "none", variant: "normal", onClick: function () {
                            var _a;
                            (_a = hiddenFileUploadInput.current) === null || _a === void 0 ? void 0 : _a.click();
                        }, ariaLabel: i18nStrings.uploadFiles, disabled: isUploading }, { children: [_jsx("input", { "data-testid": i18nStrings.uploadFiles, ref: hiddenFileUploadInput, hidden: true, type: "file", multiple: true, onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                    var files;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _b.trys.push([0, , 2, 3]);
                                                files = Array.from((_a = e.target.files) !== null && _a !== void 0 ? _a : []).map(function (file) { return ({
                                                    file: file,
                                                    path: file.name,
                                                }); });
                                                return [4 /*yield*/, actions.uploadFiles(files)];
                                            case 1:
                                                _b.sent();
                                                return [3 /*break*/, 3];
                                            case 2:
                                                // Need to reset the input value to allow uploading the same file multiple times
                                                if (hiddenFileUploadInput.current) {
                                                    hiddenFileUploadInput.current.value = "";
                                                }
                                                return [7 /*endfinally*/];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); } }), i18nStrings.uploadFiles] }))), children, _jsx(Button, { ariaLabel: i18nStrings.refreshAriaLabel, iconName: "refresh", onClick: actions.triggerRefetch, loading: isFetching || isUploading }), isUploading && (_jsx(CenterContent, __assign({ vertical: true, horizontal: true }, { children: "".concat(i18nStrings.uploading, " ").concat((uploadingFileIndex + 1).toLocaleString(), "/").concat(uploadingFileCount.toLocaleString()) })))] })), _jsx(Box, {})] })));
};
